import React from 'react';
import { Column } from 'mage-components';

import SummaryField from './SummaryField';

const SummaryColumn = props => (
  <Column columns={{ tablet: 6 }}>
    <SummaryField {...props} />
  </Column>
);

SummaryColumn.propTypes = SummaryField.propTypes;

export default SummaryColumn;
